import React,{useState, useEffect, useRef} from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { COOKIESPREFIX } from '../config';
import { getUserInfo, insertRedirectRecords } from '../services/service';
import './nav.css'

function App({isNavOpen,closeNav,gameData:data}) {
    const [gameData, setGameData] = useState(data||null)
    const [delayNav, setDelayNav] = useState(false)
    const navigate = useNavigate()
    const [cookies, setCookie, removeCookie] = useCookies([`@${COOKIESPREFIX}_token`]);
    const [popType, setPopType] = useState(null)
    const [isLoaded, setIsLoaded] = useState(false)
    const navRef = useRef(null)
    useEffect(() => {
      async function getGameState(){
        const userToken = cookies[`@${COOKIESPREFIX}_token`]
        if(!userToken) return;
        const res = await getUserInfo(userToken)
        if(res.data === null || res.errno) {
          removeCookie(`@${COOKIESPREFIX}_token`)
          return navigate('/')
        }
        const gameInfo = res.data?.data
        console.log(gameInfo)
        setGameData(res.data)
      }
      if(!gameData)
        getGameState()
    },[gameData])
    // useEffect(() => {
    //     let timer = undefined
    //     if(!isNavOpen){
    //         timer = setTimeout(() => setDelayNav(isNavOpen), 200)
    //         setTimeout(() => {
    //             if(navRef.current)navRef.current.style.display = 'none'
    //         },200)
    //     }else{
    //         if(navRef.current)navRef.current.style.display = 'flex'
    //         setDelayNav(isNavOpen)
    //     }
    // },[isNavOpen])

    useEffect(() => {
      let timer= setTimeout(()=>{
        if(navRef.current)navRef.current.style.display = 'flex'
      },500)
      return ()=>{
        if(timer) clearTimeout(timer)
      }
    },[])

    function closingNav(){
        closeNav(false)
    }
    const location = useLocation();
    const navigating = (path) => {
      navigate(path)
      if(path===location.pathname)
        navigate(0)
    }
    // if(!delayNav) return <></>
    return (
    <div ref={navRef} className="flex-col items-left absolute top-[0px]" style={{display:'none',zIndex:999, transition:'.5s all ease', left: isNavOpen ? 0 : '-100vw', width: '100vw'}}>
          {popType !== null && <div className='absolute w-[100%] h-[100%] overscroll-none' style={{backdropFilter: 'blur(10px)', zIndex:99}}>
            <div className='absolute top-[0%] left-[0] select-none flex justify-end w-full bg-white'>
              <img src='/images/tctop.png' className='w-[100%]'></img>
            </div>
            <div className='h-[100vh] w-[100%] flex flex-col items-center justify-center bg-white'>
              <div className='max-h-[100vh] w-[100%] flex flex-col px-[4%] py-[15%] relative'>
                <div className='absolute right-[5%] top-[3%] select-none flex justify-end' onClick={() => {closingNav();setPopType(null);}}>
                  <img src='/images/btn/closetnc.png' className='w-[50%]'></img>
                </div>
                <div id={'tnc-scroll'} className='h-full w-full flex flex-col overflow-y-scroll text-[12px] mt-[30%] text-justify'>
                  <div className='font-bold text-[18px] mb-[14px] w-full bg-[#f0f0f0]'>「崇光啟德店探索之旅」遊戲之條款及細則</div>
                  <div className='font-bold mb-[14px] underline'>「崇光啟德店探索之旅」 之一般條款及細則：</div>
                  <div className=''>「崇光啟德店探索之旅」(下稱「<b>本推廣</b>」) 打卡遊戲(下稱「打卡遊戲」)屬於中銀信用卡(國際)有限公司(下稱「<b>卡公司</b>」)之推廣活動。「打卡遊戲」由Zephyr Design Studio Limited (「本公司」)營運及管理，而獎賞派發會由卡公司提供。</div>
                  <div style={{whiteSpace:'pre-wrap'}}>{}</div>
                  <div className='mt-[12px]'>推廣期：</div>
                  <div>本推廣由即日至2025年2月28日結束(下稱「<b>推廣期</b>」)，日期及時間紀錄以本公司之伺服器接收為準。</div>
                  <div className='underline mt-[12px] font-bold'>成為「合資格參加者條件」：</div>
                  <div>於推廣期內，參加者須開立遊戲賬戶，透過完成遊戲並符合指定條件，便有機會獲得由卡公司送出的獎賞。</div>
                  <ol>
                    <div className='flex flex-row'>
                      <div className='font-bold'>1.</div>
                      <div className=''>有關開立遊戲賬戶的條件：</div>
                    </div>
                    <div className='flex flex-row ml-[14px]'>
                      <div className='font-bold'>i.</div>
                      <div className=''>參加者需要輸入一個可接收短訊驗證碼之香港流動電話號碼，以建立賬戶之用戶(「<b>合資格參加者</b>」)。</div>
                    </div>
                    <div className='flex flex-row'>
                      <div className='font-bold'>2.</div>
                      <div className=''>每位合資格參加者只可參與活動遊戲一次。</div>
                    </div>
                    <div className='flex flex-row'>
                      <div className='font-bold'>3.</div>
                      <div className=''>若合資格參加者的參加資格存疑，卡公司及本公司將有最終決定權，及將不承擔任何損失，也不會就參加資格及相關獎賞以任何形式補發。</div>
                    </div>
                  </ol>
                  <div className='underline mt-[12px]'>遊戲玩法：</div>
                  <ul>
                    <div className='flex flex-row'>
                      <div className='font-bold'>1.</div>
                      <div className=''>合資格參加者將透過揀選不同的購物達人角色去挑戰關卡以完成任務(「任務」)，當成功挑戰，即「任務」完成可自動獲得相應達人角色的獎賞(「合資格獎賞」)。當合資格參加者完成任務後將獲得獎賞二維碼，並可憑此二維碼到獎賞中銀崇光活動專櫃(G-10店，Longchamp旁)兌換獎賞。</div>
                    </div>
                    <div className='flex flex-row'>
                      <div className='font-bold'>2.</div>
                      <div className=''>合資格參加者完成任務後可選擇領取其達人角色之扭蛋機遊戲機會一次，以獲得其所揀選購物達人角色之「合資格獎賞」一份，唯所有達人角色之「合資格獎賞」的價值為相同的獎賞。中銀崇光活動專櫃的工作人員將會為合資格參加者送上相應的獎賞。
                    </div>
                    </div>
                    <div className='flex flex-row'>
                      <div className='font-bold'>3.</div>
                      <div className=''>每日派出的「合資格獎賞」均設有固定名額，並根據合資格參加者達到完成任務的時間及到達獎賞換領點去兌換獎賞的時間為準，以先到先得的形式給予獎賞予用戶。</div>
                    </div>
                    <div className='flex flex-row'>
                      <div className='font-bold'>4.</div>
                      <div className=''>「合資格獎賞」的名額有限，先到先得，送完即止，卡公司及本公司將不承擔任何損失，也不會將獎賞補發給合資格參加者。</div>
                    </div>
                  </ul>
                  <div className='underline mt-[12px] font-bold'>免責聲明：</div>
                  {['本公司會盡力將儲存在「打卡遊戲」遊戲系統內的個人資料保密，免受到不必要的盜取及使用，但鑑於互聯網的性質，本公司不能對資料傳送安全和保密作出完全保證或聲明。若閣下發現資料在未經授權下遭洩漏，請立即與本公司聯絡。',
                    '與「打卡遊戲」連結的其他網站，也可能蒐集你個人的資料，本公司 「打卡遊戲」的私隱條款將不適用於瀏覽者從「打卡遊戲」連結到其他網站及繼續閱讀其他網站時被收集個人資料，你須自行承擔有關風險，本公司對於連結其他網站上所載資訊的準確性、有效性、安全性或如有任何遺漏，均不承擔任何責任。',
                    '如有任何因網絡、電話、技術或不可歸責於 本公司及卡公司的事由，而使參加者所寄出的、登錄的資料或使本公司及卡公司寄出的通知，有遲延、遺失、錯誤、無法辬識或損毀的情況， 本公司及卡公司不會負任何法律責任。',
                    '參加者如因參加「打卡遊戲」或因遊戲獎項而遭任何損失，本公司及卡公司不會負任何責任。一旦得獎者領取獎品後，若有遺失或被竊，本公司及卡公司亦不會發給任何證明或補償。',
                  ].map((word,i) => 
                  <div className='flex flex-row' key={word}>
                    <div className='font-bold'>{i+1}.</div>
                    <div className=''>{word}</div>
                  </div>)}
                  <div className='underline mt-[12px] font-bold'>一般條款及細則：</div>
                  {['上述產品、服務與優惠受有關條款約束，詳情請參閱相關宣傳品、向有關商戶或中銀香港及/或卡公司職員查詢。',
                    '所有資料及圖片只供參考。',
                    '網頁及/或應用程式的使用條款須受供應商的相關條款所約束。中銀香港及/或卡公司並非流動支付工具應用程式的供應商。客戶如對商戶之網頁及/或流動支付工具應用程式有任何查詢或投訴，請直接與商戶及/或有關供應商聯絡。中銀香港及/或卡公司並不會對商戶之網頁及/或供應商提供的手機應用程式或其服務作出任何保證，或對於使用其手機應用程式或服務時所構成的後果負責。',
                    '中銀香港及/或卡公司並無審閱或核實商戶之網頁及/或第三方流動應用程式內的資訊或其刊載或提供的資料、産品或服務或私隱慣例的責任，且一概不就使用上述各項所産生的任何損失承擔責任（不論疏忽或其他方式）。中銀香港及/或卡公司並非認同或推薦該網頁及/或流動應用程式所刊載或提供的任何資訊、資料、産品或服務，亦一概不就該等流動應用程式所刊載或提供的資訊、資料、産品或服務的任何的不確或失當負責。請審閱有關第三方流動應用程式載有的條款及條件、相關免責聲明及私隱政策。',
                    '客戶需自行支付瀏覽網頁及/或第三方流動應用程式所產生的相關數據費用。',
                    '除有關客戶、中銀香港及/或卡公司以外，並無其他人士有權按《合約(第三者權利)條例》強制執行本條款及細則的任何條文或享有本條款及細則任何條文下的利益。',
                    '中銀香港及/或卡公司並非商戶的供應商。客戶如對商戶提供的貨品或其服務有任何查詢或投訴，請直接與有關商戶聯絡。中銀香港及/或卡公司對商戶及/或其供應商提供的貨品或服務質素(包括但不限於產品質素及供應量)一概不承擔任何責任，不會作出任何保證，亦不會對於使用其貨品或服務時所構成的後果負責。商戶將負上所有產品及服務的法律責任。',
                    '中銀香港及/或卡公司及/或商戶保留更改、暫停或取消本推廣或修訂本條款及細則之酌情權。',
                    '如有任何爭議，中銀香港及/或卡公司及/或商戶對所有事宜及爭議保留最終決定權。',
                    '如此條款及細則的中、英文版有所差異，一概以中文版為準。',
                  ].map((word,i) => 
                  <div className='flex flex-row' key={word}>
                    <div className='font-bold'>{i+1}.</div>
                    <div className=''>{word}</div>
                  </div>)}
                  <div className='mt-[12px]'>提示：借定唔借？還得到先好借！</div>
                  <div className='font-bold text-[18px] mt-[14px] w-full bg-[#f0f0f0]'>個人收集資料聲明</div>
                  <div className='underline mt-[12px] font-bold'>個人資料用途：</div>
                  <div className='flex flex-row' key={'「打卡遊戲」由 Zephyr Desi'}>
                    <div className='font-bold'>{1}.</div>
                    <div>
                      「打卡遊戲」由 Zephyr Design Studio Limited (「本公司」)營運及管理，而獎賞派發安排會由中銀信用卡(國際)有限公司(下稱「<b>卡公司</b>」)管理。
                    </div>
                  </div>
                  {[
                    '本公司所收集的個人資料(定義見「個人資料」於個人資料(私隠)條例之定義)，包括玩家於登記時透過填寫登記表格向本公司提供的電話及/或電郵地址。如果客戶有需要更改個人資料，可於遊戲內提交申請，透過手機短訊一次性密碼驗證後可到本公司指定網頁更改個人資料。',
                    '參加者於本活動提供予本公司之個人資料只會分享予卡公司於活動爭議時作為獎品後補派發聯絡之用及保留紀錄之用途。如你不同意將你的個人資料交予本公司，你便未能成功開立遊戲賬戶，你應當自行評估相關風險。',
                    '參加者於本活動提供予本公司之個人資料將會在活動完結後2個月後銷毀。',
                    '卡公司及本公司不會對上述安排之安全性作出任何保證及對你因以上安排所產生的任何損失作出䏽償及承擔任何責任。如對活動有任何查詢或更改資料，可以聯絡卡公司或本公司查詢。',
                  ].map((word,i) => 
                  <div className='flex flex-row' key={word}>
                    <div className='font-bold'>{i+2}.</div>
                    <div className=''>{word}</div>
                  </div>)}
                  <br/><br/>
                  <br/><br/>
                  <br/><br/>
                </div>
                <div className='w-full mb-[24px] flex justify-center items-ceter'>
                  <img src='/images/btn/back.png' className='cursor-pointer max-w-[50%]' onClick={() => {closingNav();setPopType(null);}}/>
                </div>
              </div>
            </div>
          </div>}
        <div className={'relative'}>
            <div className='w-full relative'>
              <img onLoad={() => setIsLoaded(true)} src='/images/navbg.png' width={'100%'}/>
              <div onClick={() => closeNav(false)} className='absolute w-full h-full top-0 left-0'></div>
              <div onClick={() => closeNav(false)} className='w-[10%] h-[4%] absolute top-[6%] left-[57%]' style={{zIndex:9999}}></div>
            </div>
            {isLoaded && <div className='absolute top-[0] left-[0] w-[40vw] h-full text-[#163661] font-[600] text-[21px] py-[30vw] mx-[10vw] flex flex-col items-start' style={{gap: '8vw'}}>
                <div onClick={() => {navigating('/');}} className='underline underline-offset-8 decoration-[#dcc99b]'>返回首頁</div>
                {cookies[`@${COOKIESPREFIX}_token`] && <div onClick={() => navigating('/gamemap')} className='underline underline-offset-8 decoration-[#dcc99b]'>返回遊戲</div>}
                {gameData?.data?.progress1 && <div onClick={() => {navigating('/gamemap/true');closeNav()}} className='underline underline-offset-8 decoration-[#dcc99b]'>返回禮物兌換</div>}
                <div onClick={() => {navigating('/rules');}} className='underline underline-offset-8 decoration-[#dcc99b]'>遊戲規則</div>
                <div onClick={() => {navigating('/info');}} className='underline underline-offset-8 decoration-[#dcc99b]'>聯絡我們</div>
                <div onClick={() => setPopType(true)} className='underline underline-offset-8 decoration-[#dcc99b]'>活動條款及細則</div>
                <div className='underline underline-offset-8 decoration-[#dcc99b]' onClick={()=>{
                  closeNav();
                  insertRedirectRecords('https://www.bochk.com/s/a/sogocard')
                  window.open(`https://www.bochk.com/s/a/sogocard`, '_blank');
                }}>
                    申請中銀崇光Visa信用卡
                </div>
            </div>}
        </div>
    </div>)
}
export default App;